export const TECHNOLOGY_CATEGORY_FIELD_TO_NAME_MAP = new Map([
    ["server", "Server"],
    ["data", "Data"],
    ["hosting", "Hosting"],
    ["frontEnd", "Front-End"],
    ["styling", "Styling"],
    ["frameworks", "Frameworks"],
    ["libraries", "Libraries"],
]);

export const TECHNOLOGY_NAME_TO_URL_AND_ICON_MAP = new Map([
    [
        "Node.js",
        { url: "https://nodejs.org", iconName: "node-js" },
    ],
    [
        "Heroku",
        { url: "https://heroku.com/", iconName: "heroku" },
    ],
    [
        "AWS S3",
        { url: "https://aws.amazon.com/s3/", iconName: "aws-s3" },
    ],
    [
        "Vanilla JS",
        { url: "http://www.vanilla-js.com/", iconName: "vanilla-js" },
    ],
    [
        "PptxGenJS",
        { url: "https://gitbrent.github.io/PptxGenJS/", iconName: "pptxgenjs" },
    ],
    [
        "Netlify",
        { url: "https://www.netlify.com/", iconName: "netlify" },
    ],
    [
        "GraphQL",
        { url: "https://www.graphql.org/", iconName: "graph-ql" },
    ],
    [
        "React.js",
        { url: "https://www.reactjs.org/", iconName: "react-js" },
    ],
    [
        "CSS Modules",
        { url: "https://www.github.com/css-modules", iconName: "css-modules" },
    ],
    [
        "Gatsby",
        { url: "https://www.gatsbyjs.org/", iconName: "gatsby" },
    ],
    [
        "Express.js",
        { url: "https://www.expressjs.com/", iconName: "express-js" },
    ],
    [
        "PostgreSQL",
        { url: "https://www.postgresql.org/", iconName: "postgre-sql" },
    ],
]);
